module.exports = __webpack_public_path__ + "static/media/customerActive.e2952093.png";